// Ramène un consultant (rôle `analyst`) à ses études depuis toute autre page : l'observatoire,
// l'administration, l'espace client, la carte nationale, l'accueil. Posée autour de toutes les routes
// (main.tsx). Sans effet pour les autres comptes et pour les visiteurs non connectés (dont le
// Chromium qui imprime les PDF).
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { pagePermiseAuConsultant, ROLE_CONSULTANT } from './consultant'

export default function GardeConsultant({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  const { pathname } = useLocation()
  if (user?.role === ROLE_CONSULTANT && !pagePermiseAuConsultant(pathname)) return <Navigate to="/etudes" replace />
  return <>{children}</>
}
